import React from 'react';
import glamorous from 'glamorous';

import { media, font } from '../../styles';
import { propTypes, defaultProps } from './types';

export const rules = {
  fontWeight: 300,
  fontSize: font.getFontSize(2),
  lineHeight: font.getLineHeight(1.25),

  [media('sm')]: {
    fontSize: font.getFontSize(2.5),
    lineHeight: font.getLineHeight(1.25),
  },

  [media('md')]: {
    fontSize: font.getFontSize(3),
    lineHeight: font.getLineHeight(1.3),
  },
};

const style = ({ align, glamStyle, theme, children, ...props }) => ({
  ...rules,
  textAlign: align,
  ...props,
  ...glamStyle,
});

const baseStyle = style({});
const H1 = glamorous.h1(baseStyle, style);

class Title extends React.PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  render() {
    const {
      children,
      style,
      ...rest,
    } = this.props;

    return (
      <H1 {...rest} glamStyle={style}>
        {children}
      </H1>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/typography/Title.js